<template>
  <div class="detail">
    <div class="content" style="text-align: left;">
      <div v-if="type == '1'" v-html="vold.content"></div>
      <div v-if="type == '2'">
        <h2 style="margin-bottom: 0; text-align: center;">{{vold.title}}</h2>
        <div v-html="vold.richText"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'vold',
  data () {
    return {
      vold: {},
      type: '1'
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      if(this.$route.params.id){
        this.type = this.$route.query.type;
        if(this.type == '1'){
          //查详情
          this.$store.dispatch('ajaxActDetail',{
            id: this.$route.params.id,
            jobcode: 'L075703'
          }).then((result) => {
            this.vold = result;
          })
        }else{
          //查动态
          this.$store.dispatch('ajaxNewList',{
            actId: this.$route.params.id,
            pageIndex: 1,
            pageSize: 200
          }).then((result) => {
            if(result.data.length > 0){
              this.getNewDetail(result.data[0].id)
            }
          }) 
        }
      }
    },
    getNewDetail (nid) {
      //查动态详情
      this.$store.dispatch('ajaxNewDetail',{
        id: nid,
        jobcode: 'L075703'
      }).then((result) => {
        this.vold = result;
      }) 
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/detail';
</style>

<style scoped>
  p{
    font-size: 16px !important;
    line-height: 30px !important;
  }
  span{
    font-size: 16px !important;
    font-family: 'PingFang-Regular', 'Microsoft Yahei', Arial, Helvetica, sans-serif !important;
    line-height: 30px !important;
  }
</style>